import { DSMeta } from 'shared-definitions/types'

interface MetaRecordsProps {
  records: readonly DSMeta[]
}

const MetaRecords: React.VFC<MetaRecordsProps> = ({ records }) => (
  <>
    {records.map((value, index) => (
      // Semantic key, index-suffixed. Bare array indexes here are ambiguous across
      // `next/head` instances: on hydration Next dedupes ALL collected head children
      // by React key, and the numeric keys collided with another Head list, silently
      // dropping every tag past the collision point from the live DOM (SSR HTML was
      // fine — only the hydrated head lost og:site_name/twitter/description). The
      // index suffix keeps legitimate repeats (e.g. Yoast article:tag) distinct.
      <meta key={`${value.name ?? value.property ?? 'meta'}-${index}`} {...value} />
    ))}
  </>
)

export default MetaRecords
